<script setup lang="ts">
import WidgetToolbar from '@components/widget/widgetToolBar/WidgetToolbar.vue'
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import WidgetWorkplacePostTemplatesView from './widgetWorkplacePostTemplatesView.vue'
import { getRecords } from './api'

import type { RecordType } from './types'
import type { FieldClass } from '@/api/fields'
import type { IViewConfig } from '@/types/serverField.type'

const { config, field, readonly, uuid } = defineProps<{
  field: FieldClass
  config?: IViewConfig
  readonly?: boolean
  uuid: string
}>()

const route = useRoute()
const parentID = computed(() => uuid || (route.params.uuid as string) || '')
const recordsRef = ref<RecordType[]>([])
let requestId = 0

const updateRecords = async () => {
  const currentRequest = ++requestId
  if (!parentID.value) {
    recordsRef.value = []
    return
  }

  try {
    const { records } = await getRecords(parentID.value, {
      viewName: 'workplacePostTemplates',
      type: '*postTemplate.PostTemplate'
    })
    // При смене рабочего места ответ предыдущего запроса уже не актуален.
    if (currentRequest === requestId) recordsRef.value = records
  } catch (e) {
    console.error('Не удалось загрузить посты рабочего места:', e)
  }
}

watch(parentID, () => {
  recordsRef.value = []
  updateRecords()
}, { immediate: true })
</script>

<template>
  <WidgetToolbar
    v-if="config?.ToolBar?.Buttons?.length"
    :buttons="config.ToolBar.Buttons"
    :field="field"
    :parent-uuid="parentID"
    @update-data="updateRecords"
  />

  <WidgetWorkplacePostTemplatesView
    :records="recordsRef"
    :readonly="readonly"
    :config="config"
    :update-records="updateRecords"
  />
</template>
